<div class="content-container">
    <mat-card class="login-component">
        <mat-card-header class="login-header">
            <mat-card-title class="mat-card-title">
                <mat-icon class="material-symbols-outlined">
                    theater_comedy
                </mat-icon>
                <span>
                    Acting Profile: {{ this.itemEnvelope?.ItemId }}: {{ this.itemEnvelope?.ItemName }}
                </span>
            </mat-card-title>
            <mat-card-subtitle class="mat-card-subtitle">
                (subtitle)
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <form>
                <div class="flex-direction-horizontal">
                    <div class="flex-container-basic">
                        <app-image srcPath="{{ this.itemEnvelope?.Document?.Item?.AvatarBlobPath == null ? appService.defaultImageUri : this.itemEnvelope?.Document?.Item?.AvatarBlobPath }}" isApiImage="{{ this.itemEnvelope?.Document?.Item?.AvatarBlobPath == null ? 'false' : 'true' }}" className="app-image-medium app-image-circle"></app-image>
                    </div>
                    <div class="flex-direction-vertical flex-container-basic">
                        <mat-form-field appearance="outline">
                            <mat-label>Name</mat-label>
                            <input *ngIf="itemEnvelope" matInput name="Name" placeholder="First Name" [(ngModel)]="itemEnvelope.Document.Item.Name" />
                        </mat-form-field>
                        <br />
                        <app-chip-selector #resourceChipSelector idLinkPath="resource" label="Resource" className="width-medium-narrow" [isMultiSelect]="false" [availableItems]="availableResources" [selectedItemIds]="selectedResourceIds"></app-chip-selector>
                    </div>
                </div>
            </form>
            <mat-tab-group (selectedTabChange)="onTabChange($event)">
                <br />
                <mat-tab label="General">
                    <br />
                    <mat-form-field appearance="outline">
                        <mat-label>Gender</mat-label>
                        <mat-select *ngIf="this.itemEnvelope" name="Gender" [(ngModel)]="this.itemEnvelope.Document.Item.GenderId">
                            <mat-option *ngFor="let gender of availableGenders" [value]="gender.GenderId">{{ gender.UID }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <br />
                    <span>
                        <app-chip-selector *ngIf="this.itemEnvelope" #ethnicitySelector label="Ethnicity" className="width-medium-narrow" [isMultiSelect]="true" [availableItems]="availableEthnicities" [value]="selectedEthnicityIds"></app-chip-selector>
                    </span>
                    <br />
                    <span>
                        <app-chip-selector *ngIf="this.itemEnvelope" #characterTypeChipSelector label="Can Play" className="width-medium-narrow" [isMultiSelect]="true" [availableItems]="availableCharacterTypes" [value]="selectedCharacterTypeIds"></app-chip-selector>
                    </span>
                    <br />
                    <span *ngIf="this.itemEnvelope">
                        <mat-form-field class="input-narrow" appearance="outline">
                            <mat-label>Age Range (Lower)</mat-label>
                            <input matInput name="AgeRangeYearsLower" [(ngModel)]="this.itemEnvelope.Document.Item.AgeRangeYearsLower" />
                        </mat-form-field>
                        &nbsp;
                        &nbsp;
                        <mat-form-field class="input-narrow" appearance="outline">
                            <mat-label>Age Range (Lower)</mat-label>
                            <input matInput name="AgeRangeYearsUpper" [(ngModel)]="this.itemEnvelope.Document.Item.AgeRangeYearsUpper" />
                        </mat-form-field>
                    </span>
                    <br />
                    <mat-form-field *ngIf="this.itemEnvelope" style="width: 100%;" appearance="outline">
                        <mat-label>Pitch</mat-label>
                        <textarea matInput name="Pitch" placeholder="(Enter pitch details)" [(ngModel)]="this.itemEnvelope.Document.Item.Pitch"></textarea>
                    </mat-form-field>
                </mat-tab>
                <mat-tab *ngIf="!isRevisionMode" label="History">
                    <div class="history-container">
                        <div class="history-container-section">
                            <app-history #appHistory *ngIf="this.itemEnvelope" [itemEnvelope]="this.itemEnvelope" [itemService]="this.itemService"></app-history>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </mat-card-content>
        <mat-card-footer>
        </mat-card-footer>
    </mat-card>
</div>

